// components/layout/DashboardContainer.tsx
import React from "react";
import { Menu } from "lucide-react";
import { Button } from "@/components/ui/button";
import MenuBar from "@/components/MenuBar";
import { Card, CardHeader, CardContent } from "@/components/ui/card";

interface DashboardContainerProps {
  children: React.ReactNode;
  title?: string | React.ReactNode;
  headerContent?: React.ReactNode;
}

const DashboardContainer: React.FC<DashboardContainerProps> = ({
  children,
  title,
  headerContent,
}) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = React.useState(false);

  return (
    <div className="flex min-h-screen bg-background">
      {/* Mobile Menu Toggle */}
      <div className="md:hidden fixed top-0 left-0 right-0 z-30 flex items-center p-4 bg-gray-900">
        <Button
          variant="ghost"
          size="icon"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className="text-white"
        >
          <Menu className="h-6 w-6" />
        </Button>
      </div>

      {/* Sidebar */}
      <div
        className={`${
          isMobileMenuOpen ? "block" : "hidden"
        } md:block fixed md:relative w-64 h-full bg-gray-900 z-20`}
      >
        <MenuBar />
      </div>

      {/* Main Content */}
      <div className="flex-1 md:ml-0 overflow-hidden mt-16 md:mt-0">
        <div className="p-4 md:p-6">
          <Card>
            {(title || headerContent) && (
              <CardHeader>
                <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                  {title && (
                    typeof title === 'string' ? (
                      <h2 className="text-2xl font-bold">{title}</h2>
                    ) : (
                      title
                    )
                  )}
                  {headerContent}
                </div>
              </CardHeader>
            )}
            <CardContent>{children}</CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default DashboardContainer;
